import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SectionContainer from "@project/templates/home/SectionContainer";
const PriceSection = (props) => {
    const { page } = props;
    const { contents } = page || {};
    const { titlePricePart, descriptionPricePart, priceDynamicPart, cardPrice } = contents;
    return (_jsx(SectionContainer, { backgroundColor: "primary.main", hasDarkBackground: true, children: _jsxs(Stack, { direction: { xs: "column", lg: "row" }, spacing: { xs: 4, lg: 8 }, sx: { alignItems: "center", justifyContent: "space-between" }, children: [_jsxs(Stack, { spacing: 2, sx: { maxWidth: 550 }, children: [_jsx(Typography, { component: "h2", variant: "h2", sx: {
                                color: "primary.contrastText",
                            }, children: titlePricePart }), descriptionPricePart && (_jsx(Typography, { variant: "body1", sx: {
                                color: "primary.contrastText",
                            }, children: descriptionPricePart })), priceDynamicPart] }), cardPrice] }) }));
};
export default PriceSection;
